<template>
    <div class="yszc-container">
        <div class="header">
            <h2 style="text-align: center;">{{ appName }}VIP(会员)服务协议</h2>
        </div>
        <div class="content">
            <p>欢迎您使用{{ appName }}VIP(会员)服务，{{ appName }}平台（以下简称"{{ appName }}"）是由{{ companyName }}（以下简称"{{ appName
                }}公司"）向用户提供的一款智能剪辑软件。</p>
            <p><b>特别提醒：</b></p>
            <p>1.在您（或称"用户"）开始阅读并决定是否接受《{{ appName }}VIP(会员)服务协议》（下称"本协议"或"会员服务协议"）和付费开通{{ appName
                }}VIP(会员)服务之前，<b>特别提醒您仔细阅读并留意本协议中的加粗内容，未满14周岁的未成年人用户请在监护人陪同下仔细阅读本协议并决定是否同意接受本协议，并在监护人的引导,监督下购买并使用{{
                    appName }}VIP(会员)服务。</b>若您对本协议存在疑问，或者无法全部或者部分接受本协议，或者在使用过程中需要向{{ appName }}公司反馈等，您可以通过以下方式联系我们：</p>
            <p>官方邮箱：qihaoyun2021@163.com</p>
            <p><b>一、{{ appName }}VIP(会员)服务说明</b></p>
            <p><b>1.{{ appName }}VIP(会员)：</b>是指完成购买{{ appName }}VIP(会员)的所有程序，且在遵守本协议的前提下，在会员有效期内享受{{ appName
                }}提供的VIP(会员)服务的用户</p>
            <p><b>2.{{ appName }}VIP(会员)服务：</b>是由{{ appName }}向您提供的由{{ appName
                }}VIP(会员)专享的权益，该服务为收费服务，需要您额外付费购买，具体权益内容请您查看本协议的第二条</p>
            <p><b>3.{{ appName
                    }}VIP(会员)协议：</b>本协议为《用户协议》、《隐私政策》的补充协议，本协议为上述协议不可分割的组成部分，与其具有同等的法律效力，<b>若本协议与上述协议冲突，以本协议为准，本协议未提及的部分以上述协议为准</b>
            </p>
            <p><b>二、{{ appName }}VIP(会员)权益：</b></p>
            <p><b>1.权益：</b>会员有效期内可使用视频剪辑、视频混剪、图文制作等和页面标注的会员功能</p>
            <p><b>{{ appName }}可能会根据法律法规及政策变更、自身运营策略等因素对上述会员权益作出部分修改、包括但不限于更改优惠政策等</b></p>
            <p><b>三、收费及退订相关</b></p>
            <p><b>1.收费方式：</b>{{ appName }}VIP(会员)为收费服务，您可以通过支付宝、微信支付、IOS内购买等第三方支付渠道完成会员费用支付</p>
            <p><b>2.费用退还：</b>{{ appName }}VIP(会员)系网络商品和虚拟商品，采用先收费后服务的方式，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定价等性质。因此{{
                appName }}VIP(会员)一旦购买成功后，已表明您已经使用了该商品，成功购买后暂不支付退款</p>
            <p><b>3.收费标准：</b>收费标准由{{ appName
                }}公司根据公司的运营成本、运营策略等综合考虑后独立决定（调整包括但不限于促销、涨价等），并在相关的产品服务宣传及支付也页面向您展示；若您在购买和续费时，相关收费方式发生改变的，以{{ appName
                }}实际接受的收费方式为准；请您仔细阅读相关通知</p>
            <p><b>4.自动续费退订方式：</b></p>
            <p>(1)IOS用户：请手动打开iPhone的[设置]，点击头像进入[Apple ID]设置，点击[订阅]，选择订阅中的[{{ appName
                }}]取消订阅即可。取消订阅应当在会员服务扣费前的24小时前完成，否则此订阅将继续有效</p>
            <p>(2)支付宝：打开[支付宝]，进入[我]-[设置]-[支付设置]-[免密支付/自动扣费]，选择[{{ appName }}自动续费服务]关闭服务</p>
            <p><b>三、会员规范及违规处理</b></p>
            <p><b>1.在您使用{{ appName }}VIP(会员)服务过程中，不得存在以下行为：</b></p>
            <p>（1）通过技术手段对服务内容、服务期限、消费金额、交易状态等信息进行修改以获得{{ appName }}VIP(会员)服务的</p>
            <p>（2）将{{ appName }}VIP(会员)服务提供他人使用（包括但不限于转移、赠与、借用、转让、销售等）</p>
            <p>（3）任何通过非法不正当手段或利用漏洞获得{{ appName }}VIP(会员)服务或进行恶意退款的</p>
            <p>（4）其他违反《用户协议》、本协议、法律法规或监管政策及任何违反第三方合法权益的行为</p>
            <p><b>2.若您违反本协议和/或《用户协议》，{{ appName }}有权根据自身的判断或法律与政策的需要，自主决定并可不在预先通知您的情况下，全部或者部分选择：</b></p>
            <p>（1）暂停或终止对您的{{ appName }}VIP(会员)服务，采取包括但不限于限制、终结、或终止{{ appName }}VIP(会员)服务措施，并由您自行承担{{ appName
                }}VIP(会员)服务无法使用的后果，您已支付的费用不作退还</p>
            <p>（2）诉诸行政执法机构或者司法机关，以追究相关法律责任。若因您违反本协议导致第三方损害的，您应当独立承担责任；{{ appName }}公司及其关联公司遭受损失的，您也应当依法赔偿</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VipService',
    data() {
        return {
            appName: this.$siteConfig.siteName, // 使用配置文件中的网站名称
            companyName: this.$siteConfig.companyName // 使用配置文件中的公司名称
        };
    },
    mounted() {
        // 从URL参数中获取appName，如果没有则使用配置文件中的默认值
        const paramAppName = this.$route.query.appname;
        if (paramAppName && typeof paramAppName === 'string') {
            this.appName = paramAppName;
        }

        // companyname 为空时使用 appname，便于同一页面适配不同应用
        const paramCompanyName = this.$route.query.companyname;
        if (typeof paramCompanyName === 'string' && paramCompanyName.trim()) {
            this.companyName = paramCompanyName.trim();
        } else {
            this.companyName = this.appName;
        }

        // 更新页面标题
        document.title = `${this.appName}-会员服务协议`;

        // 更新meta标签
        const descriptionMeta = document.querySelector('meta[name="description"]');
        if (descriptionMeta) {
            descriptionMeta.setAttribute('content', this.$siteConfig.siteDescription);
        }

        const keywordsMeta = document.querySelector('meta[name="keywords"]');
        if (keywordsMeta) {
            keywordsMeta.setAttribute('content', this.$siteConfig.siteKeywords);
        }

        // 设置页面icon
        const iconLink = document.querySelector('link[rel="shortcut icon"]') || document.createElement('link');
        iconLink.setAttribute('rel', 'shortcut icon');
        iconLink.setAttribute('type', 'image/x-icon');
        iconLink.setAttribute('href', '');
        if (!document.querySelector('link[rel="shortcut icon"]')) {
            document.head.appendChild(iconLink);
        }
    }
};
</script>

<style scoped>
.yszc-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.header {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.content {
    line-height: 1.8;
    color: #333;
}

.content p {
    margin-bottom: 16px;
    text-indent: 2em;
}

.content h2 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-size: 1.5rem;
    color: #2c3e50;
    font-weight: bold;
}

h2 {
    font-size: 24px;
    margin-bottom: 20px;
    color: #2c3e50;
}

.content h3 {
    margin-top: 20px;
    margin-bottom: 12px;
    font-size: 1.2rem;
    color: #333;
    font-weight: bold;
}

.content b {
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/service/VipService.vue